export default __webpack_public_path__ + "static/media/italy.8e7424d2.svg";